<!--
 * @Description:
 * @Date: 2019-04-28 13:17:06
 -->
<style>
.el-dropdown {
  vertical-align: top;
}

.el-dropdown + .el-dropdown {
  margin-left: 15px;
}

.el-icon-arrow-down {
  font-size: 12px;
}
</style>
<style scoped>
.photo {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.user-box {
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 1em;
}
</style>

<template>
  <div class>
    <el-dropdown>
      <div class="user-box">
        <img
          src="http://cdn.yxvzb.com/KLN-Admin/images/%E7%94%A8%E6%88%B7.png"
          style="margin-right:5px"
        />
        <span>{{ user.userName }}</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          @click.native="pCenter"
          v-if="$store.getters.isMaster"
        >
          个人中心
        </el-dropdown-item>
        <el-dropdown-item
          @click.native="showForm('revisePassword')"
          v-if="user.isMainAccountNumber == 1 && initPwd == 0"
        >
          修改密码
        </el-dropdown-item>
        <el-dropdown-item
          @click.native="setPassword()"
          v-if="$store.getters.isMaster && initPwd == 1"
        >
          设置密码
        </el-dropdown-item>
        <el-dropdown-item @click.native="logout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <component v-if="componentName" :is="componentName" />
  </div>
</template>

<script>
import createExtend from '@C/createExtend';
import resetPasswordDialog from '@/page/login/components/resetPasswordDialog.vue';
import { login } from '@/api/ajax';
import { getStorage, setStorage } from '@/tools/storage';
import { logout } from '@/api/ajax';
import revisePassword from '@/page/account/components/revisePassword.vue';

export default {
  data() {
    return {
      initPwd: getStorage('showPs') ? getStorage('showPs').initPwd : 0, //1设置密码 0修改密码
      user: {},
      componentName: ''
    };
  },
  components: { revisePassword },
  computed: {},
  methods: {
    //设置密码
    setPassword() {
      let resetPasswordDialogDom = createExtend(resetPasswordDialog, {
        titles: '设置密码',
        placeholders: '再次输入密码',
        dialogVisibles: true
      });
      resetPasswordDialogDom.$on('confirm', async compRes => {
        let password = {
          password: compRes.resetForm.pass
        };
        try {
          await login.setUserPwd(password).then(async res => {
            if (res.data.status == '1') {
              let showPs = getStorage('showPs');
              showPs.initPwd = 0;
              this.initPwd = 0;
              setStorage('showPs', showPs);
              this.$message.success('设置密码成功！');
              compRes.isShowDialog();
            } else {
              this.$message.error('设置密码失败');
            }
          });
        } catch (error) {
          compRes.showIsLoading();
        }
      });
    },
    showForm(name) {
      this.componentName = name;
    },
    pCenter() {
      this.$router.push({
        name: 'pCenter'
      });
    },
    handleClick() {
      alert('button click');
    },
    async logout() {
      //退出
      await logout();
      localStorage.clear();
      sessionStorage.clear();
      this.$store.commit('SET_MENUS', []);
      this.$store.commit('SET_ACCESS_PROJECT', []);
      location.reload();
    }
  },
  created() {
    this.user = getStorage('user');
  }
};
</script>
